import React from 'react';

const PageSizeSelector = ({ 
    pageSize, 
    setPageSize, 
    setCurrentPage,
    options = [10, 50, 100],
    includeAll = true,
    allValue = 100000,
    width = 80,
    label = "Show",
    suffix = "records"
}) => {
    const handlePageSizeChange = (e) => {
        if (e.target.value === 'all') {
            setPageSize(allValue);
        } else {
            setPageSize(parseInt(e.target.value, 10));
        }
        if (setCurrentPage) {
            setCurrentPage(1);
        }
    };

    return (
        <div className="d-flex align-items-center gap-2">
            <label htmlFor="pageSizeSelect" className="me-2 mb-0">{label}</label>
            <select
                id="pageSizeSelect"
                className="form-select form-select-sm"
                style={{ width }}
                value={pageSize === allValue ? 'all' : pageSize}
                onChange={handlePageSizeChange}
            >
                {options.map(option => (
                    <option key={option} value={option}>{option}</option>
                ))}
                {includeAll && <option value="all">All</option>}
            </select>
            <span className="ms-2 mb-0">{suffix}</span>
        </div>
    );
};

export default PageSizeSelector;